import * as React from 'react';

import {SelectTwoLine} from 'shells/select-two-line/select-two-line';

type TwoLineOption = {
    value: any;
    label: string;
    sublabel: string;
};

type State = {
    columns: TwoLineOption[];
    selectedOption: TwoLineOption | null | undefined;
};

export class ImportUnsubscribes extends React.Component<Record<any, any>, State> {
    constructor() {
        // @ts-expect-error
        super();

        this.state = {
            columns: [],
            selectedOption: null,
        };
    }

    componentDidMount() {
        this.fetchColumns();
    }

    render() {
        const {columns, selectedOption} = this.state;

        return (
            <div>
                <p>Which column contains the email addresses you would like to unsubscribe?</p>
                <SelectTwoLine
                    options={columns}
                    placeholder='Select a column'
                    value={selectedOption}
                    // @ts-expect-error
                    onChange={(option) => this.handleSelectOption(option)}
                />
            </div>
        );
    }

    handleSelectOption = (option: TwoLineOption) => {
        this.setState({selectedOption: option});

        const columnNumber = this.state.columns.indexOf(option);

        Nut.ajax.post({
            url: '/setup/import-account-contact-csv/update-unsubscribe-email-address-column-number',
            data: {unsubscribeEmailAddressColumnNum: columnNumber},
        });
    };

    receivedColumns = (data: any) => {
        const columns = data.columns;

        this.setState({columns: columns});
    };

    fetchColumns = () => {
        Nut.ajax.get({
            url: '/setup/import-account-contact-csv/columns',
            success: this.receivedColumns,
        });
    };
}
